/*
 * ts-common is the basic building blocks of our typescript projects
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Dispatcher } from './dispatcher.js';
/**
 * Severity levels for server errors, ordered from least to most severe.
 */
export var ServerErrorSeverity;
(function (ServerErrorSeverity) {
    ServerErrorSeverity["Debug"] = "Debug";
    ServerErrorSeverity["Info"] = "Info";
    ServerErrorSeverity["Warning"] = "Warning";
    ServerErrorSeverity["Error"] = "Error";
    ServerErrorSeverity["Critical"] = "Critical";
})(ServerErrorSeverity || (ServerErrorSeverity = {}));
/**
 * Array of error severities in ordinal order (least to most severe).
 * Useful for comparisons and sorting.
 */
export const ServerErrorSeverity_Ordinal = [
    ServerErrorSeverity.Debug,
    ServerErrorSeverity.Info,
    ServerErrorSeverity.Warning,
    ServerErrorSeverity.Error,
    ServerErrorSeverity.Critical
];
/**
 * Dispatcher for application notifications.
 *
 * Use this to notify all modules that implement `OnApplicationNotification`
 * about application-level events.
 */
export const dispatch_onApplicationNotification = new Dispatcher('__processApplicationNotification');
/**
 * Dispatcher for application exceptions.
 *
 * Use this to notify all modules that implement `OnApplicationException`
 * about exceptions that occur at the application level.
 */
export const dispatch_onApplicationException = new Dispatcher('__processApplicationException');
//# sourceMappingURL=error-handling.js.map